<template>
    <div class="user-lists-modal unfollow-list-dialog">

        <!-- Shadow -->
        <div class="user-lists-modal__shade" @click="closeModal"></div>

        <!-- Modal -->
        <div class="user-lists-modal__inner" v-if="currentList">

            <!-- Close Modal -->
            <span class="user-lists-modal__close" @click="closeModal">
                <svg class='close'><use xlink:href="#close"></use></svg>
            </span>

            <!-- Header -->
            <h2>Unfollow List</h2>

            <p>Are you sure you want to unfollow the list {{ currentList.title }}?</p>

            <!-- Form -->
            <form method="post" :action="`/${this.currentList.user.username}/lists/${this.currentList.id}`" @submit.prevent="submit">
                <div class="form__button">
                    <button type="submit"
                            :class="{ 'is-submitting': form.isSubmitted }"
                            :disabled="form.isSubmitted"
                            class="button">
                        {{ form.isSubmitted ? 'Unfollowing' : 'Unfollow List' }}
                        <svg class='arrow-right-2'><use xlink:href="#arrow-right-2"></use></svg>
                    </button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>

import Form from '@/classes/Form'

export default {

    props: ['list'],

    data() {
        return {
            currentList: this.list,
            form: new Form({
                list_id: this.list ? this.list.id : null
            }).dontClear(),
        }
    },

    created() {
        eventBus.$on('open-unfollow-list-modal', (list) => {
            this.currentList = list;
            this.form.list_id = list.id;
            this.openModal();
        });
    },

    methods: {

        submit() {
            this.form.post(`/lists/follow`)
                .then(response => {
                    eventBus.$emit('list-deleted', response)
                    this.closeModal()
                })
                .catch(errors => {
                    console.log(errors)
                })
        },

        openModal(){
            $('.unfollow-list-dialog').fadeIn()
        },

        closeModal(){
            $('.unfollow-list-dialog').fadeOut();
        }
    },

    watch:{
        list(){
            this.form.list_id = this.list.id
        }
    }
}
</script>
